import React from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';

const colorOptions = [{
  label: 'Job Status',
  value: 'jobStatus'
}, {
  label: 'Job Type',
  value: 'jobType'
}, {
  label: 'Office',
  value: 'office'
}, {
  label: 'Salesperson',
  value: 'salesperson'
}];

const apptcolorOptions = [{
  label: 'Office',
  value: 'office'
}, {
  label: 'Salesperson',
  value: 'salesperson'
}];


const style = {
  minWidth: '200px'
};

const bidTypeOption = (bidType) => (
  <span>
    <FontAwesome name="square" style={{ color: bidType.color || '#fafafa' }} /> {bidType.value}
  </span>
);

const jobStatusOption = (jobStatus) => (
  <span>
    <FontAwesome name="square" style={{ color: jobStatus.color || '#fafafa' }} /> {jobStatus.status}
  </span>
);

const jobTypeOption = (jobType) => (
  <span>
    <FontAwesome name="square" style={{ color: jobType.color || '#fafafa' }} /> {jobType.name}
  </span>
);

const salespersonOption = ({ calendarColor, firstName, lastName }) => (
  <span>
    <FontAwesome name="square" style={{ color: calendarColor || '#fafafa' }} /> {`${firstName || ''} ${lastName || ''}`}
  </span>
);

const Filters = ({ bidTypes, filters, jobStatuses, jobTypes, offices, onFilterUpdate, salespeople,settings }) => {
  
   
     //console.log(salespeople);
  

  if(settings.entity==="appointments")
  {
    return (
      <div style={style}>    
       <FormGroup>
      <ControlLabel>Office</ControlLabel>
      <Select
        labelKey="name"
        multi
        options={offices}
        placeholder="All"
        value={filters.offices || []}
        valueKey="id"
        onChange={(e) => onFilterUpdate({ offices: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Salesperson</ControlLabel>
      <Select
        multi
        labelKey = "labelKey"
        optionRenderer={salespersonOption}
        options={salespeople}
        placeholder="All"
        value={filters.salespeople || []}
        valueKey="id"
        valueRenderer={salespersonOption}
        onChange={(e) => onFilterUpdate({ salespeople: e })}
      />
    </FormGroup>

   
    <FormGroup>
      <ControlLabel>Color</ControlLabel>
      <Select
        clearable={false}
        options={apptcolorOptions}
        value={filters.color}
        onChange={(e) => onFilterUpdate({ color: e.value })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Sort</ControlLabel>
      <Select
        clearable={false}
        options={filters.SortTypes}
        value={filters.sortoption}
        onChange={(e) => onFilterUpdate({ sortoption: e.value })}
      />
    </FormGroup>
        </div>)

  }
  else
  {
  return (
  <div style={style}>    
    <FormGroup>
      <ControlLabel>Job Status</ControlLabel>
      <Select
        labelKey="status"
        multi
        optionRenderer={jobStatusOption}
        options={jobStatuses}
        placeholder="All"
        value={filters.jobStatuses || []}
        valueKey="value"
        valueRenderer={jobStatusOption}
        onChange={(e) => onFilterUpdate({ jobStatuses: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Job Type</ControlLabel>
      <Select
        labelKey="name"
        multi
        optionRenderer={jobTypeOption}
        options={jobTypes}
        placeholder="All"
        value={filters.jobTypes || []}
        valueKey="id"
        valueRenderer={jobTypeOption}
        onChange={(e) => onFilterUpdate({ jobTypes: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Bid Type</ControlLabel>
      <Select
        labelKey="value"
        multi
        optionRenderer={bidTypeOption}
        options={bidTypes}
        placeholder="All"
        value={filters.bidTypes || []}
        valueKey="value"
        valueRenderer={bidTypeOption}
        onChange={(e) => onFilterUpdate({ bidTypes: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Office</ControlLabel>
      <Select
        labelKey="name"
        multi
        options={offices}
        placeholder="All"
        value={filters.offices || []}
        valueKey="id"
        onChange={(e) => onFilterUpdate({ offices: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Salesperson</ControlLabel>
      <Select
        multi
        labelKey = "labelKey"
        optionRenderer={salespersonOption}
        options={salespeople}
        
        placeholder="All"
        value={filters.salespeople || []}
        valueKey="id"
        valueRenderer={salespersonOption}
        onChange={(e) => onFilterUpdate({ salespeople: e })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Color</ControlLabel>
      <Select
        clearable={false}
        options={colorOptions}
        value={filters.color}
        onChange={(e) => onFilterUpdate({ color: e.value })}
      />
    </FormGroup>
    <FormGroup>
      <ControlLabel>Sort</ControlLabel>
      <Select
        clearable={false}
        options={filters.SortTypes}
        value={filters.sortoption}
        onChange={(e) => onFilterUpdate({ sortoption: e.value })}
      />
    </FormGroup>
  </div>
)}


};

export default Filters;
